import * as angular from "angular";
import {IController, ITimeoutService} from "angular";
import * as _ from "lodash";
import {AgentRequests} from "../../services/agent-requests.service";
import {AgentsAlerts} from "../../services/agents-alerts.service";
import {AgentModel} from "../../angular/models/agent.model";
import {TasksService} from "../../../tasks/services/tasks-service.service";
import {ConfirmChangeStateService} from "../../../commons/services/confirm-change-state.service";
import {TaskModel} from "../../../tasks/models/task.model";

export class AgentItineraryEditModeCtrl implements IController {

  agent: AgentModel;
  tasks: any;
  isBundleView: any;
  modifyItineraryChanged: any;
  saveEdit: Function;

  onClose: Function;
  onSave: Function;
  onChange: Function;
  onAnalysis: Function;
  onReset: Function;

  private loading: any;
  private canceled: any;

  private inActiveStatuses: any;
  private internalTaskDayTypes: any;
  private internalTaskRouteTypes: any;
  private internalTaskTypes: any;
  private counterRef: any;
  private defaultCountValue: any;
  private counter: any;
  private taskIdsToUpdate: any;
  private treeOptions: any;

  constructor(private $log, private $timeout: ITimeoutService, private agentsAlerts: AgentsAlerts, private itinerariesConstant,
              private confirmChangeStateService: ConfirmChangeStateService, private agentRequests: AgentRequests, private tasksService: TasksService,
              private tasksConstants) {
  }

  $onInit() {

    // Sets the transition from this component as confirm prompt
    this.confirmChangeStateService.setIsEnabled(true);

    this.inActiveStatuses = this.itinerariesConstant.inActiveTaskStatuses;
    this.internalTaskDayTypes = this.tasksConstants.internalTaskDayTypes;
    this.internalTaskRouteTypes = this.tasksConstants.internalTaskRouteTypes;
    this.internalTaskTypes = this.tasksConstants.internalTaskTypes;

    this.defaultCountValue = 5;
    this.counter = undefined;
    this.taskIdsToUpdate = [];
    this.canceled = false;
  }

  $onChanges(changes) {

    if (changes.tasks && !changes.tasks.isFirstChange()) {

    }

    if (changes.modifyItineraryChanged && !changes.modifyItineraryChanged.isFirstChange()) {
      this.agentsAlerts.itineraryChangeInfo();
    }
  };

  $onDestroy() {
    // Reset transition confirmation prompt
    this.confirmChangeStateService.reset();
  };

  onTasksChange(taskIds) {
    this._initTimer(taskIds);
  }

  onDragStart() {
    this.counter = undefined;
  }


  onSaveEditItinerary() {
    this.loading = true;
    this.counter = undefined; // for stopping the timeout
    const taskIdsToUpdate = this.taskIdsToUpdate?.length ? this.taskIdsToUpdate : _.map(this.tasks, 'id');
    this.onSave({taskIds: taskIdsToUpdate})
  }

  // ******************************
  //        Internal methods
  // ******************************

  // checkItineraryEditMode(taskIdsForServerCheck) {
  //   this.loading = true;
  //   return new Promise((resolve, reject) => {
  //     this.agentRequests.checkEditItinerary(this.agent.id, taskIdsForServerCheck)
  //       .then((checkResponse) => {
  //         this.loading = false;
  //         resolve(checkResponse);
  //       })
  //       .catch((error) => {
  //         this.$log.error('Failed to check Itinerary in edit mode', error);
  //         reject();
  //       })
  //   });
  // }

  onCloseEdit() {
    this.canceled = true;
    this.onClose();

    // Update Angularjs Cycle
    this.$timeout(0).then(() => {});
  }

  _initTimer(taskIds) {
    this.counter = this.defaultCountValue;
    this.taskIdsToUpdate = taskIds;
    this.counterRef = () => {
      if (this.counter >= 0) {
        this.counter = this.counter - 1 / 10;
        this.$timeout(this.counterRef, 100);
      }
      if (this.counter < 0 && !this.canceled) {
        this.counter = undefined;
        const taskIds = angular.copy(this.taskIdsToUpdate);
        this.taskIdsToUpdate = [];
        this.onChange({taskIds: taskIds})
      }
    };
    this.counterRef();
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentItineraryEditMode', {
    bindings: {
      agent: '<',
      tasks: '<',
      isBundleView: '<',
      modifyItineraryChanged: '<',
      saveEdit: '&',
      onClose: '&',
      onSave: '&',
      onChange: '&',
      onAnalysis: '&',
      onReset: '&'
    },
    template: require('./agent-itinerary-edit-mode.html').default,
    controller: AgentItineraryEditModeCtrl
  });
